(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-card-hearts]').forEach((layer) => {
    const media = layer.closest('.gg-card__media') || layer.parentElement;
    const count = Math.max(1, Math.min(20, Number(layer.dataset.count) || 6));
    const originY = Number(layer.dataset.origin) || 85;
    const MAX_HEARTS = 45;
    let lastFired = 0;
    const prefersReduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const burst = () => {
      const now = Date.now();
      if (now - lastFired < 1200 || prefersReduced()) return;
      lastFired = now;
      const box = layer.getBoundingClientRect();
      for (let i = 0; i < count; i += 1) {
        const heart = document.createElement('span');
        heart.className = 'gg-heart';
        heart.style.setProperty('--size', (18 + Math.random() * 14).toFixed(1) + 'px');
        heart.style.setProperty('--x', (box.width * (0.1 + Math.random() * 0.8)).toFixed(1) + 'px');
        heart.style.setProperty('--y', (box.height * (originY / 100) + (Math.random() * 10 - 5)).toFixed(1) + 'px');
        heart.style.setProperty('--dx', (Math.random() * 70 - 35).toFixed(1) + 'px');
        heart.style.setProperty('--rise', (80 + Math.random() * 70 + count * 3).toFixed(1) + 'px');
        heart.style.setProperty('--dur', (1.5 + Math.random() * 0.9).toFixed(2) + 's');
        heart.style.setProperty('--delay', Math.round(i * 110 + Math.random() * 150) + 'ms');
        heart.addEventListener('animationend', () => heart.remove());
        layer.appendChild(heart);
      }
      while (layer.children.length > MAX_HEARTS) layer.firstElementChild.remove();
    };
    media.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') burst();
    });
    media.addEventListener('click', burst);
    // No hover on touch screens: play the hearts once when the image scrolls into view.
    if ('IntersectionObserver' in window && window.matchMedia && window.matchMedia('(hover: none)').matches) {
      const watch = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          watch.disconnect();
          burst();
        }
      }, { threshold: 0.6 });
      watch.observe(media);
    }
  });

  document.querySelectorAll('[data-gg-widget]').forEach((fig) => {
    const holder = fig.querySelector('.gg-wo, .gg-widget');
    const slot = fig.querySelector('.plg-impact');
    if (!holder || !slot) return;
    const watch = () => {
      const frame = slot.querySelector('iframe');
      if (!frame || frame.dataset.ggWatched) return;
      frame.dataset.ggWatched = '1';
      const markLive = () => {
        if (frame.offsetHeight > 20) {
          holder.setAttribute('data-live', '');
          return true;
        }
        return false;
      };
      if (markLive()) return;
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
          if (markLive()) ro.disconnect();
        });
        ro.observe(frame);
      } else {
        frame.addEventListener('load', () => setTimeout(markLive, 1500));
      }
    };
    watch();
    if ('MutationObserver' in window) new MutationObserver(watch).observe(slot, { childList: true });
  });

  document.querySelectorAll('[data-gg-wo]').forEach((wo) => {
    const bar = wo.querySelector('.gg-wo__bar');
    const fit = () => wo.style.setProperty('--s', (bar.getBoundingClientRect().width / 420).toFixed(4));
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(wo);
    else window.addEventListener('resize', fit);
  });

  document.querySelectorAll('[data-gg-widget]').forEach((fig) => {
    const load = () => {
      if (fig.dataset.loaded) return;
      fig.dataset.loaded = '1';
      if (document.querySelector('script[data-gg-widget-js]')) return;
      const script = document.createElement('script');
      script.async = true;
      script.src = fig.dataset.script;
      script.setAttribute('data-gg-widget-js', '');
      document.head.appendChild(script);
    };
    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }
    new IntersectionObserver((entries, observer) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        load();
        observer.disconnect();
      }
    }, { threshold: 0.25 }).observe(fig);
  });

  // Replay the count-up each time the live counter scrolls back into view, so it shows activity.
  if ('IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    document.querySelectorAll('[data-gg-widget]').forEach((fig) => {
      let seenOut = false;
      let last = 0;
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            seenOut = true;
            return;
          }
          const frame = fig.querySelector('.plg-impact iframe');
          const now = Date.now();
          if (!seenOut || !frame || !frame.src || now - last < 6000) return;
          seenOut = false;
          last = now;
          frame.style.transition = 'opacity 0.25s ease';
          frame.style.opacity = '0';
          frame.addEventListener('load', () => { frame.style.opacity = '1'; }, { once: true });
          setTimeout(() => { frame.src = frame.src; }, 250);
          setTimeout(() => { frame.style.opacity = '1'; }, 4000);
        });
      }, { threshold: 0.6 }).observe(fig);
    });
  }

  document.querySelectorAll('[data-gg-frames]').forEach((box) => {
    const imgs = Array.from(box.querySelectorAll('.gg-frames__img'));
    if (imgs.length < 2) return;
    const interval = Math.max(600, Number(box.dataset.interval) || 2500);
    let index = 0;
    let timer = null;
    const show = (i) => {
      index = i;
      imgs.forEach((img, n) => img.classList.toggle('is-active', n === i));
    };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      show(Math.min(1, imgs.length - 1));
      return;
    }
    const start = () => {
      if (timer) return;
      timer = setInterval(() => show((index + 1) % imgs.length), interval);
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
    }, { threshold: 0.5 }).observe(box);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-estimator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-est]').forEach((root) => {
    const q = (s) => root.querySelector(s);
    const orders = q('[data-gg-est-orders]');
    const rate = q('[data-gg-est-rate]');
    const gift = q('[data-gg-est-gift]');
    const month = q('[data-gg-est-month]');
    const year = q('[data-gg-est-year]');
    const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    const update = () => {
      const o = Math.max(0, parseFloat(orders.value) || 0);
      const r = Math.min(100, Math.max(0, parseFloat(rate.value) || 0)) / 100;
      const g = Math.max(0, parseFloat(gift.value) || 0);
      const m = o * r * g;
      month.textContent = fmt.format(m);
      year.textContent = fmt.format(m * 12);
    };
    [orders, rate, gift].forEach((el) => el.addEventListener('input', update));
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-faq-tabs]').forEach((bar) => {
    const tabs = Array.from(bar.querySelectorAll('[role="tab"]'));
    const glider = bar.querySelector('.gg-faq__glider');
    if (!tabs.length) return;

    const place = (tab) => {
      glider.style.width = tab.offsetWidth + 'px';
      glider.style.transform = 'translateX(' + (tab.offsetLeft - 4) + 'px)';
    };

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
        if (on) {
          place(tab);
          if (focus) tab.focus();
        }
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          select(next, true);
        }
      });
    });

    const current = () => Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
    window.addEventListener('resize', () => place(tabs[current()]));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => place(tabs[current()]));
    place(tabs[current()]);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-guides"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-guide-tabs]').forEach((bar) => {
    const tabs = Array.from(bar.querySelectorAll('[role="tab"]'));
    const glider = bar.querySelector('.gg-guides__glider');
    if (!tabs.length) return;

    const place = (tab) => {
      glider.style.width = tab.offsetWidth + 'px';
      glider.style.transform = 'translateX(' + (tab.offsetLeft - 4) + 'px)';
    };

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
        if (on) {
          place(tab);
          if (focus) tab.focus();
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          select(next, true);
        }
      });
    });

    const current = () => Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
    window.addEventListener('resize', () => place(tabs[current()]));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => place(tabs[current()]));
    place(tabs[current()]);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-demo]').forEach((demo) => {
    const base = 24.99;
    const buttons = demo.querySelectorAll('[data-gg-demo-amt]');
    const line = demo.querySelector('[data-gg-demo-line]');
    const lineAmt = demo.querySelector('[data-gg-demo-line-amt]');
    const total = demo.querySelector('[data-gg-demo-total]');
    const thanks = demo.querySelector('[data-gg-demo-thanks]');
    const money = (n) => '$' + n.toFixed(2);
    const layer = demo.querySelector('[data-gg-hearts]');
    const MAX_HEARTS = 45;
    const prefersReduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const spawnHearts = (btn) => {
      if (!layer || prefersReduced()) return;
      const amount = Number(btn.getAttribute('data-gg-demo-amt')) || 1;
      const lr = layer.getBoundingClientRect();
      const br = btn.getBoundingClientRect();
      for (let i = 0; i < amount; i += 1) {
        const heart = document.createElement('span');
        heart.className = 'gg-heart';
        heart.style.setProperty('--size', (20 + Math.random() * 16).toFixed(1) + 'px');
        heart.style.setProperty('--x', (br.left - lr.left + br.width * (0.1 + Math.random() * 0.8)).toFixed(1) + 'px');
        heart.style.setProperty('--y', (br.top - lr.top + br.height * 0.3).toFixed(1) + 'px');
        heart.style.setProperty('--dx', (Math.random() * 80 - 40).toFixed(1) + 'px');
        heart.style.setProperty('--rise', (100 + Math.random() * 80 + amount * 3).toFixed(1) + 'px');
        heart.style.setProperty('--dur', (1.5 + Math.random() * 0.9).toFixed(2) + 's');
        heart.style.setProperty('--delay', Math.round(i * (amount > 5 ? 60 : 120) + Math.random() * 150) + 'ms');
        heart.addEventListener('animationend', () => heart.remove());
        layer.appendChild(heart);
      }
      while (layer.children.length > MAX_HEARTS) layer.firstElementChild.remove();
    };
    buttons.forEach((btn) => {
      let lastFired = 0;
      const fire = () => {
        const now = Date.now();
        if (now - lastFired < 500) return;
        lastFired = now;
        spawnHearts(btn);
      };
      btn.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') fire();
      });
      btn.addEventListener('click', fire);
    });
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const wasOn = btn.getAttribute('aria-pressed') === 'true';
        buttons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        const amount = wasOn ? 0 : Number(btn.getAttribute('data-gg-demo-amt'));
        if (!wasOn) btn.setAttribute('aria-pressed', 'true');
        line.hidden = !amount;
        thanks.hidden = !amount;
        lineAmt.textContent = money(amount);
        total.textContent = money(base + amount);
        thanks.textContent = amount ? 'Thank you! Your ' + money(amount) + ' donation is added.' : '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-options"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = () => document.querySelector('[data-gg-opt-section]');
    const panels = () => Array.from(document.querySelectorAll('.gg-opt__panel'));
    const buttons = () => Array.from(document.querySelectorAll('[data-gg-more]'));
    const setOpen = (index, scroll) => {
      const sec = section();
      if (!sec) return;
      panels().forEach((panel, i) => { panel.hidden = i !== index; });
      buttons().forEach((btn) => {
        const on = Number(btn.dataset.ggMore) === index;
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        btn.textContent = on ? btn.dataset.ggLessLabel : btn.dataset.ggMoreLabel;
      });
      sec.hidden = index < 0;
      if (index >= 0 && scroll) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const panel = panels()[index];
        panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        panel.focus({ preventScroll: true });
      }
    };
    document.addEventListener('click', (event) => {
      const more = event.target.closest('[data-gg-more]');
      if (more) {
        const i = Number(more.dataset.ggMore);
        setOpen(more.getAttribute('aria-expanded') === 'true' ? -1 : i, true);
        return;
      }
      const close = event.target.closest('[data-gg-opt-close]');
      if (close) {
        const i = Number(close.dataset.ggOptClose);
        setOpen(-1, false);
        const btn = buttons().find((b) => Number(b.dataset.ggMore) === i);
        if (btn) btn.focus();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = panels().findIndex((p) => !p.hidden);
      if (open < 0) return;
      setOpen(-1, false);
      const btn = buttons().find((b) => Number(b.dataset.ggMore) === open);
      if (btn) btn.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg-sticky]').forEach((bar) => {
    bar.hidden = false;
    const hide = new Set();
    const update = () => bar.classList.toggle('is-away', hide.size > 0);
    const targets = document.querySelectorAll('.gg-hero, #get-started');
    if (!('IntersectionObserver' in window) || !targets.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? hide.add(e.target) : hide.delete(e.target)));
      update();
    }, { threshold: 0.15 });
    targets.forEach((t) => io.observe(t));
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
